<template>
	<div>
		<common-header navbar-index=2></common-header>
		<robot-banner></robot-banner>
		<div class="container" id="link1">
			<div class="tips mt-5 pt-4 pb-4">
				<a href="javascript:void(0)" @click="toback">行业新闻</a><span class="s1">|</span><span class="s2">科促会智工委秘书长吕斌锐：发展人工智能重在推动青少年编程教育普及</span>
			</div>
			<div class="content_item pt-4 pb-5">
				<div class="pl25 pr25">
					<div class="title mb-4">科促会智工委秘书长吕斌锐：发展人工智能重在推动青少年编程教育普及</div>
					<p class="text">　　3月20日上午，中国国际科技促进会青少年人工智能教育普及工作委员会秘书长吕斌锐受邀做客中国网创新中国，并围绕开展青少年人工智能教育普及的时代背景、我国出台的相关政策、教育部门的相关措施等内容进行讲述。人工智能是新一轮科技革命和产业变革的重要驱动力量。自2016年以来，已有美、英、德、日、韩、印度等18个国家启动了国家人工智能战略。</p>
					<p style="text-align:center"><img alt="" border="0" height="400" src="../../../assets/img/robot/article/3_1.png" style="border:0px; margin:0px; padding:0px" title="" vspace="0" width="600"></p>
					<p class="text">　　2017年7月20日，国务院印发《新一代人工智能发展规划》，规划提出了三步走的战略：第一步，到2020年人工智能总体技术和应用与世界先进水平同步，人工智能产业成为新的重要经济增长点。第二步，到2025年人工智能基础理论实现重大突破，部分技术与应用达到世界领先水平。第三步，到2030年，人工智能理论、技术与应用总体达到世界领先水平，成为世界主要人工智能创新中心。要求实施全民智能教育项目，在中小学阶段设置人工智能相关课程，逐步推广编程教育，鼓励社会力量参与寓教于乐的编程教学软件、游戏的开发和推广。</p>
					<p class="text">　　计算机编程教育作为人工智能的核心课程，被许多国家提高到了国家战略高度。2012年日本在中小学普及编程教育科目，2014年英国教育大纲规定计算机编程是5-16岁儿童必修课程，2015年美国政府投资40亿美元开展青少年编程教育，发起“编程一小时”的运动。2016年，美国强制要求高中毕业必修计算机编程学分。2017年，新加坡全面推动青少年编程教育，中小学考试中加入编程考试科目……目前，全球已有24个国家将编程课纳入基础教育体系。</p>
					<p style="text-align:center"><img alt="" border="0" height="400" src="../../../assets/img/robot/article/3_2.png" style="border:0px; margin:0px; padding:0px" title="" vspace="0" width="600"></p>
					<p class="text">　　与国外相比，我国编程教育则处在起步阶段，人工智能人才短缺。据有关数值统计，2025年时有关人才的缺口将达到1200-1500万。2018年4月2日，教育部网站发布关于印发《高等学校人工智能创新行动计划》的通知，明确提出形成“人工智能+X”复合专业培养新模式。加强教材建设，加快人工智能领域科技成果和资源向教育教学转化，推动人工智能重要方向的教材和在线开放课程建设。目前，重庆、山东、浙江、深圳、江苏等多个省市出台了相应的改革措施。</p>
					<p class="text">　　吕斌锐秘书长最后介绍说，智工委将紧紧围绕青少年人工智能教育普及这一主题，通过开展各类培训和评测活动，提升广大师生的人工智能教育的应用水平。智工委目前已通过教育体系内和体系外的两条主线，建立了近200个城市的教育服务中心和1500个培训点，服务对象超过1万名教师和10万名学生。接下来，智工委还将与200所学校深度合作，建立各地的人工智能教育示范基地，重点推动青少年编程教育的普及，更好地为广大青少年服务。</p>
					<p class="text">&nbsp;</p>
					<p style="text-align:left">原文链接：
						<a target="_blank" href="http://www.robotest.cn/article/item-333.html">http://www.robotest.cn/article/item-333.html</a>
					</p>
					<div class="clear"></div>
				</div>
			</div>
		</div>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	import RobotBanner from '@/pages/robot/components/RobotBanner'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'Article3',
		components: {
			CommonHeader,
			RobotBanner,
			CommonFooter
		},
		data() {
			return {}
		},
		methods: {
			toback() {
				this.$router.push({
					path: '/robot/desc'
				})
			}
		},
		mounted() {
			document.getElementById('link1').scrollIntoView()
		}
	};
</script>

<style lang="scss" scoped>
	.content_item a {
		color: #000000;
		text-decoration: none;
	}
	
	div.title {
		font-size: 22px;
		font-weight: 600;
		text-align: center;
		letter-spacing: 2px;
	}
	
	p.tag {
		font-size: 20px;
		font-weight: 600;
		margin-top: 30px;
	}
	
	p.text {
		font-size: 16px;
		line-height: 30px;
		letter-spacing: 1px;
	}
	
	div.tips {
		border-bottom: 3px solid #F0F0F0;
		a {
			font-size: 24px;
			font-weight: 600;
			color: #333;
			text-decoration: none;
			cursor: pointer;
			letter-spacing: 2px;
			&:hover {
				color: #f39c12;
			}
		}
		.s1 {
			padding: 0 15px;
		}
		.s2 {
			letter-spacing: 2px;
			font-size: 18px;
		}
	}
</style>